import type { THIRD_PARTY_SENSOR_CARD_DETAILS_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/third-party-sensor-details-card/third-party-sensor-details-card.fr.ts";

export const THIRD_PARTY_SENSOR_CARD_DETAILS_CARD_ENGLISH_LOCALE = {
  title: "Third party sensor details",
} satisfies typeof THIRD_PARTY_SENSOR_CARD_DETAILS_CARD_FRENCH_LOCALE;
